import React from 'react';
import { TimezoneList } from './TimezoneList';
import EmptyStateMessage from './EmptyStateMessage';
import { DisplayTime } from './DisplayTime';

interface MainContentProps {
  timezones: any[];
  local_timezone: string;
  is24hFormat: boolean;
  currentTime: any;
  onRemoveTimezone: (id: string) => void;
  onEditTimezone: (timezone: any) => void;
  onReorderTimezones: (reorderedTimezones: any[]) => void;
}

const MainContent: React.FC<MainContentProps> = ({
  timezones,
  local_timezone,
  is24hFormat,
  currentTime,
  onRemoveTimezone,
  onEditTimezone,
  onReorderTimezones,
}) => {
  const renderHeader = () => (
    <h4>
      <DisplayTime
        timezone={local_timezone}
        is24hFormat={is24hFormat}
        currentTime={currentTime}
      />
      {timezones.length > 0 ? " in local time is:" : " in local time"}
    </h4>
  );

  return (
    <>
      {renderHeader()}
      {timezones.length > 0 ? (
        <TimezoneList
          timezones={timezones}
          local_timezone={local_timezone}
          is24hFormat={is24hFormat}
          currentTime={currentTime}
          onRemoveTimezone={onRemoveTimezone}
          onEditTimezone={onEditTimezone}
          onReorderTimezones={onReorderTimezones}
        />
      ) : (
        <EmptyStateMessage />
      )}
    </>
  );
};

export default MainContent;
